import styled, { css } from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	width: 100%;
`;

interface ISegmentProps {
	$isClickable: boolean;
	$isLoading: boolean;
}
export const Segment = styled.div<ISegmentProps>`
	flex: 1;
	display: flex;
	align-items: center;
	padding: 6px 0;
	cursor: ${({ $isLoading, $isClickable }) => ($isLoading ? "progress" : $isClickable ? "pointer" : "default")};
`;

interface IBarProps {
	$isFilled: boolean;
}
export const Bar = styled.div<IBarProps>`
	width: 100%;
	height: 4px;
	border-radius: 999px;
	background-color: ${({ theme }) => theme.neutral.n200};
	transition: background-color 0.2s;

	${({ $isFilled, theme }) =>
		$isFilled &&
		css`
			background-color: ${theme.pantone2726C};
		`}
`;
